/* eslint-disable */
import { Recipient } from "../../../../api/common/common";
import {
  Receipt,
  SalesOrder_PaymentType,
  salesOrder_PaymentTypeFromJSON,
  salesOrder_PaymentTypeToJSON,
  SalesOrder_ReceiptMethod,
  salesOrder_ReceiptMethodFromJSON,
  salesOrder_ReceiptMethodToJSON,
} from "../../../../api/orders/resources";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Announcement } from "../../common/common";
import { SalesOrder, SalesOrder_LogisticsRoute, SalesOrders } from "../../common/order_resources";

export const protobufPackage = "store.api.orders";

export interface CreateOrderRequest {
  /** Required. */
  items: CreateOrderRequest_Item[];
  /** Required. 收件人資訊 */
  recipient:
    | Recipient
    | undefined;
  /** Required. 付款方式 */
  paymentType: SalesOrder_PaymentType;
  /** Required. 前端計算的總金額 */
  total: string;
  /** Required. 退貨聲明, 海外訂單預設給true */
  returnDeclaration: boolean;
  /** Optional. 信用卡資訊, required when payment_type is PAYMENT_TYPE_CREDIT_CARD、PAYMENT_TYPE_OVERSEA */
  creditCard:
    | CreateOrderRequest_CreditCard
    | undefined;
  /** Required. 發票資訊, 海外訂單預設給捐贈 */
  receipt:
    | Receipt
    | undefined;
  /** Optional. Apple pay payment token, required when payment_type is PAYMENT_TYPE_APPLE_PAY */
  paymentToken: string;
}

export interface CreateOrderRequest_Item {
  /** Required. */
  skuId: string;
  /** Required. */
  quantity: number;
}

export interface CreateOrderRequest_CreditCard {
  /** Required. 信用卡號碼 */
  cardNumber: string;
  /** Required. 有效期限 */
  goodThru: string;
  /** Required. 背面末三碼 */
  cvv: string;
}

export interface CreateOrderResponse {
  order: SalesOrder | undefined;
  payment: PaymentMeta | undefined;
  addressId: string;
}

export interface CreatePaymentRequest {
  /** Required */
  orderId: string;
  /** Required. The return payment data is created according to this type. */
  paymentType: SalesOrder_PaymentType;
}

export interface CreatePaymentResponse {
  payment: PaymentMeta | undefined;
}

export interface PaymentMeta {
  /** payment id */
  id: string;
  /** type of this payment */
  type: SalesOrder_PaymentType;
  linepay?: PaymentMeta_LineMeta | undefined;
  esun?: PaymentMeta_EsunMeta | undefined;
}

export interface PaymentMeta_LineMeta {
  transactionId: string;
  accessToken: string;
  paymentUrlApp: string;
  paymentUrlWeb: string;
}

export interface PaymentMeta_EsunMeta {
  /** encrypted credit card payment info */
  info: string;
}

export interface CheckPaymentRequest {
  /** Required */
  orderId: string;
}

export interface CheckPaymentResponse {
  /** 訂單成立時間 */
  orderCreateTime:
    | Date
    | undefined;
  /** type of the payment */
  paymentType: SalesOrder_PaymentType;
  /** 是否成功 */
  success: boolean;
  /** 付款金額 */
  paymentTotal: string;
  /** 收件人資訊 */
  recipient:
    | Recipient
    | undefined;
  /** 付款超時時間 */
  paymentRemindTimeout:
    | Date
    | undefined;
  /** 發票類型 */
  receiptMethod: SalesOrder_ReceiptMethod;
  /** 美金兌換台幣匯率 */
  exchangeRateUsdNtd: string;
  /** 付款金額（美金） */
  paymentTotalUsd: string;
}

export interface ListOrdersRequest {
  /** 狀態. */
  state: ListOrdersRequest_State;
}

export enum ListOrdersRequest_State {
  STATE_UNSPECIFIED = 0,
  /** STATE_WAIT_SELLER_SEND - 待出貨/待付款&未完成付款也會在此狀態 */
  STATE_WAIT_SELLER_SEND = 1,
  /** STATE_WAIT_BUYER_CONFIRM - 已出貨 */
  STATE_WAIT_BUYER_CONFIRM = 2,
  /** STATE_WAIT_RATING - 待評價 */
  STATE_WAIT_RATING = 3,
  /** STATE_HAS_RETURN - 退貨進度 */
  STATE_HAS_RETURN = 4,
  /** STATE_ALL - 全部 */
  STATE_ALL = 5,
}

export function listOrdersRequest_StateFromJSON(object: any): ListOrdersRequest_State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return ListOrdersRequest_State.STATE_UNSPECIFIED;
    case 1:
    case "STATE_WAIT_SELLER_SEND":
      return ListOrdersRequest_State.STATE_WAIT_SELLER_SEND;
    case 2:
    case "STATE_WAIT_BUYER_CONFIRM":
      return ListOrdersRequest_State.STATE_WAIT_BUYER_CONFIRM;
    case 3:
    case "STATE_WAIT_RATING":
      return ListOrdersRequest_State.STATE_WAIT_RATING;
    case 4:
    case "STATE_HAS_RETURN":
      return ListOrdersRequest_State.STATE_HAS_RETURN;
    case 5:
    case "STATE_ALL":
      return ListOrdersRequest_State.STATE_ALL;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ListOrdersRequest_State");
  }
}

export function listOrdersRequest_StateToJSON(object: ListOrdersRequest_State): string {
  switch (object) {
    case ListOrdersRequest_State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case ListOrdersRequest_State.STATE_WAIT_SELLER_SEND:
      return "STATE_WAIT_SELLER_SEND";
    case ListOrdersRequest_State.STATE_WAIT_BUYER_CONFIRM:
      return "STATE_WAIT_BUYER_CONFIRM";
    case ListOrdersRequest_State.STATE_WAIT_RATING:
      return "STATE_WAIT_RATING";
    case ListOrdersRequest_State.STATE_HAS_RETURN:
      return "STATE_HAS_RETURN";
    case ListOrdersRequest_State.STATE_ALL:
      return "STATE_ALL";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ListOrdersRequest_State");
  }
}

export interface ListOrdersResponse {
  /** key is order state */
  stateOrders: { [key: number]: SalesOrders };
  /** 公告 */
  announcement: Announcement | undefined;
}

export interface ListOrdersResponse_StateOrdersEntry {
  key: number;
  value: SalesOrders | undefined;
}

export interface GetOrderRequest {
  /** 訂單編號. */
  id: string;
}

export interface GetOrderResponse {
  order: SalesOrder | undefined;
}

export interface GetOrderLogisticsRequest {
  /** 訂單編號. */
  id: string;
}

export interface GetOrderLogisticsResponse {
  /** 物流公司名稱 */
  logisticsCompanyName: string;
  /** 配送編號/物流編號 */
  shipmentTrackingNumber: string;
  /** 物流詳情 */
  routes: SalesOrder_LogisticsRoute[];
}

/**
 * 若收件電話留空白，則不修改收件電話。
 * 收件人姓名 and 收件地址 are required fields.
 */
export interface UpdateRecipientRequest {
  /** 訂單編號 */
  id: string;
  recipient: Recipient | undefined;
}

export interface CancelOrderRequest {
  /** 訂單編號 */
  id: string;
}

export interface DeleteOrderRequest {
  /** 訂單編號 */
  id: string;
}

export interface GetPaymentInfoRequest {
  /** Required. 訂單編號 */
  orderId: string;
  /** Required. encrypted credit card payment info. */
  info: string;
}

export interface GetPaymentInfoResponse {
  /** form post url. */
  url: string;
  /** post data */
  data: string;
  mac: string;
  ksn: string;
}

export interface GetOrderInvoicePDFRequest {
  /** Required. 訂單編號 */
  orderId: string;
}

export interface GetOrderInvoicePDFResponse {
  /** 發票PDF hash */
  hash: string;
}

export interface ValidatePaymentRequest {
  /** Required. 訂單編號 */
  orderId: string;
  /** Required. 信用卡回傳DATA資料 */
  data: string;
  /** Optional. 信用卡回傳MACD資料, 授權成功才有值 */
  macd: string;
}

function createBaseCreateOrderRequest(): CreateOrderRequest {
  return {
    items: [],
    recipient: undefined,
    paymentType: 0,
    total: "",
    returnDeclaration: false,
    creditCard: undefined,
    receipt: undefined,
    paymentToken: "",
  };
}

export const CreateOrderRequest = {
  fromJSON(object: any): CreateOrderRequest {
    return {
      items: Array.isArray(object?.items) ? object.items.map((e: any) => CreateOrderRequest_Item.fromJSON(e)) : [],
      recipient: isSet(object.recipient) ? Recipient.fromJSON(object.recipient) : undefined,
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
      total: isSet(object.total) ? String(object.total) : "",
      returnDeclaration: isSet(object.returnDeclaration) ? Boolean(object.returnDeclaration) : false,
      creditCard: isSet(object.creditCard) ? CreateOrderRequest_CreditCard.fromJSON(object.creditCard) : undefined,
      receipt: isSet(object.receipt) ? Receipt.fromJSON(object.receipt) : undefined,
      paymentToken: isSet(object.paymentToken) ? String(object.paymentToken) : "",
    };
  },

  toJSON(message: CreateOrderRequest): unknown {
    const obj: any = {};
    if (message.items) {
      obj.items = message.items.map((e) => e ? CreateOrderRequest_Item.toJSON(e) : undefined);
    } else {
      obj.items = [];
    }
    message.recipient !== undefined &&
      (obj.recipient = message.recipient ? Recipient.toJSON(message.recipient) : undefined);
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    message.total !== undefined && (obj.total = message.total);
    message.returnDeclaration !== undefined && (obj.returnDeclaration = message.returnDeclaration);
    message.creditCard !== undefined &&
      (obj.creditCard = message.creditCard ? CreateOrderRequest_CreditCard.toJSON(message.creditCard) : undefined);
    message.receipt !== undefined && (obj.receipt = message.receipt ? Receipt.toJSON(message.receipt) : undefined);
    message.paymentToken !== undefined && (obj.paymentToken = message.paymentToken);
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRequest>, I>>(base?: I): CreateOrderRequest {
    return CreateOrderRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderRequest>, I>>(object: I): CreateOrderRequest {
    const message = createBaseCreateOrderRequest();
    message.items = object.items?.map((e) => CreateOrderRequest_Item.fromPartial(e)) || [];
    message.recipient = (object.recipient !== undefined && object.recipient !== null)
      ? Recipient.fromPartial(object.recipient)
      : undefined;
    message.paymentType = object.paymentType ?? 0;
    message.total = object.total ?? "";
    message.returnDeclaration = object.returnDeclaration ?? false;
    message.creditCard = (object.creditCard !== undefined && object.creditCard !== null)
      ? CreateOrderRequest_CreditCard.fromPartial(object.creditCard)
      : undefined;
    message.receipt = (object.receipt !== undefined && object.receipt !== null)
      ? Receipt.fromPartial(object.receipt)
      : undefined;
    message.paymentToken = object.paymentToken ?? "";
    return message;
  },
};

function createBaseCreateOrderRequest_Item(): CreateOrderRequest_Item {
  return { skuId: "", quantity: 0 };
}

export const CreateOrderRequest_Item = {
  fromJSON(object: any): CreateOrderRequest_Item {
    return {
      skuId: isSet(object.skuId) ? String(object.skuId) : "",
      quantity: isSet(object.quantity) ? Number(object.quantity) : 0,
    };
  },

  toJSON(message: CreateOrderRequest_Item): unknown {
    const obj: any = {};
    message.skuId !== undefined && (obj.skuId = message.skuId);
    message.quantity !== undefined && (obj.quantity = Math.round(message.quantity));
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRequest_Item>, I>>(base?: I): CreateOrderRequest_Item {
    return CreateOrderRequest_Item.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderRequest_Item>, I>>(object: I): CreateOrderRequest_Item {
    const message = createBaseCreateOrderRequest_Item();
    message.skuId = object.skuId ?? "";
    message.quantity = object.quantity ?? 0;
    return message;
  },
};

function createBaseCreateOrderRequest_CreditCard(): CreateOrderRequest_CreditCard {
  return { cardNumber: "", goodThru: "", cvv: "" };
}

export const CreateOrderRequest_CreditCard = {
  fromJSON(object: any): CreateOrderRequest_CreditCard {
    return {
      cardNumber: isSet(object.cardNumber) ? String(object.cardNumber) : "",
      goodThru: isSet(object.goodThru) ? String(object.goodThru) : "",
      cvv: isSet(object.cvv) ? String(object.cvv) : "",
    };
  },

  toJSON(message: CreateOrderRequest_CreditCard): unknown {
    const obj: any = {};
    message.cardNumber !== undefined && (obj.cardNumber = message.cardNumber);
    message.goodThru !== undefined && (obj.goodThru = message.goodThru);
    message.cvv !== undefined && (obj.cvv = message.cvv);
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderRequest_CreditCard>, I>>(base?: I): CreateOrderRequest_CreditCard {
    return CreateOrderRequest_CreditCard.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderRequest_CreditCard>, I>>(
    object: I,
  ): CreateOrderRequest_CreditCard {
    const message = createBaseCreateOrderRequest_CreditCard();
    message.cardNumber = object.cardNumber ?? "";
    message.goodThru = object.goodThru ?? "";
    message.cvv = object.cvv ?? "";
    return message;
  },
};

function createBaseCreateOrderResponse(): CreateOrderResponse {
  return { order: undefined, payment: undefined, addressId: "" };
}

export const CreateOrderResponse = {
  fromJSON(object: any): CreateOrderResponse {
    return {
      order: isSet(object.order) ? SalesOrder.fromJSON(object.order) : undefined,
      payment: isSet(object.payment) ? PaymentMeta.fromJSON(object.payment) : undefined,
      addressId: isSet(object.addressId) ? String(object.addressId) : "",
    };
  },

  toJSON(message: CreateOrderResponse): unknown {
    const obj: any = {};
    message.order !== undefined && (obj.order = message.order ? SalesOrder.toJSON(message.order) : undefined);
    message.payment !== undefined && (obj.payment = message.payment ? PaymentMeta.toJSON(message.payment) : undefined);
    message.addressId !== undefined && (obj.addressId = message.addressId);
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateOrderResponse>, I>>(base?: I): CreateOrderResponse {
    return CreateOrderResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreateOrderResponse>, I>>(object: I): CreateOrderResponse {
    const message = createBaseCreateOrderResponse();
    message.order = (object.order !== undefined && object.order !== null)
      ? SalesOrder.fromPartial(object.order)
      : undefined;
    message.payment = (object.payment !== undefined && object.payment !== null)
      ? PaymentMeta.fromPartial(object.payment)
      : undefined;
    message.addressId = object.addressId ?? "";
    return message;
  },
};

function createBaseCreatePaymentRequest(): CreatePaymentRequest {
  return { orderId: "", paymentType: 0 };
}

export const CreatePaymentRequest = {
  fromJSON(object: any): CreatePaymentRequest {
    return {
      orderId: isSet(object.orderId) ? String(object.orderId) : "",
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
    };
  },

  toJSON(message: CreatePaymentRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePaymentRequest>, I>>(base?: I): CreatePaymentRequest {
    return CreatePaymentRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreatePaymentRequest>, I>>(object: I): CreatePaymentRequest {
    const message = createBaseCreatePaymentRequest();
    message.orderId = object.orderId ?? "";
    message.paymentType = object.paymentType ?? 0;
    return message;
  },
};

function createBaseCreatePaymentResponse(): CreatePaymentResponse {
  return { payment: undefined };
}

export const CreatePaymentResponse = {
  fromJSON(object: any): CreatePaymentResponse {
    return { payment: isSet(object.payment) ? PaymentMeta.fromJSON(object.payment) : undefined };
  },

  toJSON(message: CreatePaymentResponse): unknown {
    const obj: any = {};
    message.payment !== undefined && (obj.payment = message.payment ? PaymentMeta.toJSON(message.payment) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<CreatePaymentResponse>, I>>(base?: I): CreatePaymentResponse {
    return CreatePaymentResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CreatePaymentResponse>, I>>(object: I): CreatePaymentResponse {
    const message = createBaseCreatePaymentResponse();
    message.payment = (object.payment !== undefined && object.payment !== null)
      ? PaymentMeta.fromPartial(object.payment)
      : undefined;
    return message;
  },
};

function createBasePaymentMeta(): PaymentMeta {
  return { id: "", type: 0, linepay: undefined, esun: undefined };
}

export const PaymentMeta = {
  fromJSON(object: any): PaymentMeta {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      type: isSet(object.type) ? salesOrder_PaymentTypeFromJSON(object.type) : 0,
      linepay: isSet(object.linepay) ? PaymentMeta_LineMeta.fromJSON(object.linepay) : undefined,
      esun: isSet(object.esun) ? PaymentMeta_EsunMeta.fromJSON(object.esun) : undefined,
    };
  },

  toJSON(message: PaymentMeta): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type !== undefined && (obj.type = salesOrder_PaymentTypeToJSON(message.type));
    message.linepay !== undefined &&
      (obj.linepay = message.linepay ? PaymentMeta_LineMeta.toJSON(message.linepay) : undefined);
    message.esun !== undefined && (obj.esun = message.esun ? PaymentMeta_EsunMeta.toJSON(message.esun) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentMeta>, I>>(base?: I): PaymentMeta {
    return PaymentMeta.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<PaymentMeta>, I>>(object: I): PaymentMeta {
    const message = createBasePaymentMeta();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.linepay = (object.linepay !== undefined && object.linepay !== null)
      ? PaymentMeta_LineMeta.fromPartial(object.linepay)
      : undefined;
    message.esun = (object.esun !== undefined && object.esun !== null)
      ? PaymentMeta_EsunMeta.fromPartial(object.esun)
      : undefined;
    return message;
  },
};

function createBasePaymentMeta_LineMeta(): PaymentMeta_LineMeta {
  return { transactionId: "", accessToken: "", paymentUrlApp: "", paymentUrlWeb: "" };
}

export const PaymentMeta_LineMeta = {
  fromJSON(object: any): PaymentMeta_LineMeta {
    return {
      transactionId: isSet(object.transactionId) ? String(object.transactionId) : "",
      accessToken: isSet(object.accessToken) ? String(object.accessToken) : "",
      paymentUrlApp: isSet(object.paymentUrlApp) ? String(object.paymentUrlApp) : "",
      paymentUrlWeb: isSet(object.paymentUrlWeb) ? String(object.paymentUrlWeb) : "",
    };
  },

  toJSON(message: PaymentMeta_LineMeta): unknown {
    const obj: any = {};
    message.transactionId !== undefined && (obj.transactionId = message.transactionId);
    message.accessToken !== undefined && (obj.accessToken = message.accessToken);
    message.paymentUrlApp !== undefined && (obj.paymentUrlApp = message.paymentUrlApp);
    message.paymentUrlWeb !== undefined && (obj.paymentUrlWeb = message.paymentUrlWeb);
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentMeta_LineMeta>, I>>(base?: I): PaymentMeta_LineMeta {
    return PaymentMeta_LineMeta.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<PaymentMeta_LineMeta>, I>>(object: I): PaymentMeta_LineMeta {
    const message = createBasePaymentMeta_LineMeta();
    message.transactionId = object.transactionId ?? "";
    message.accessToken = object.accessToken ?? "";
    message.paymentUrlApp = object.paymentUrlApp ?? "";
    message.paymentUrlWeb = object.paymentUrlWeb ?? "";
    return message;
  },
};

function createBasePaymentMeta_EsunMeta(): PaymentMeta_EsunMeta {
  return { info: "" };
}

export const PaymentMeta_EsunMeta = {
  fromJSON(object: any): PaymentMeta_EsunMeta {
    return { info: isSet(object.info) ? String(object.info) : "" };
  },

  toJSON(message: PaymentMeta_EsunMeta): unknown {
    const obj: any = {};
    message.info !== undefined && (obj.info = message.info);
    return obj;
  },

  create<I extends Exact<DeepPartial<PaymentMeta_EsunMeta>, I>>(base?: I): PaymentMeta_EsunMeta {
    return PaymentMeta_EsunMeta.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<PaymentMeta_EsunMeta>, I>>(object: I): PaymentMeta_EsunMeta {
    const message = createBasePaymentMeta_EsunMeta();
    message.info = object.info ?? "";
    return message;
  },
};

function createBaseCheckPaymentRequest(): CheckPaymentRequest {
  return { orderId: "" };
}

export const CheckPaymentRequest = {
  fromJSON(object: any): CheckPaymentRequest {
    return { orderId: isSet(object.orderId) ? String(object.orderId) : "" };
  },

  toJSON(message: CheckPaymentRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckPaymentRequest>, I>>(base?: I): CheckPaymentRequest {
    return CheckPaymentRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CheckPaymentRequest>, I>>(object: I): CheckPaymentRequest {
    const message = createBaseCheckPaymentRequest();
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseCheckPaymentResponse(): CheckPaymentResponse {
  return {
    orderCreateTime: undefined,
    paymentType: 0,
    success: false,
    paymentTotal: "",
    recipient: undefined,
    paymentRemindTimeout: undefined,
    receiptMethod: 0,
    exchangeRateUsdNtd: "",
    paymentTotalUsd: "",
  };
}

export const CheckPaymentResponse = {
  fromJSON(object: any): CheckPaymentResponse {
    return {
      orderCreateTime: isSet(object.orderCreateTime) ? fromJsonTimestamp(object.orderCreateTime) : undefined,
      paymentType: isSet(object.paymentType) ? salesOrder_PaymentTypeFromJSON(object.paymentType) : 0,
      success: isSet(object.success) ? Boolean(object.success) : false,
      paymentTotal: isSet(object.paymentTotal) ? String(object.paymentTotal) : "",
      recipient: isSet(object.recipient) ? Recipient.fromJSON(object.recipient) : undefined,
      paymentRemindTimeout: isSet(object.paymentRemindTimeout)
        ? fromJsonTimestamp(object.paymentRemindTimeout)
        : undefined,
      receiptMethod: isSet(object.receiptMethod) ? salesOrder_ReceiptMethodFromJSON(object.receiptMethod) : 0,
      exchangeRateUsdNtd: isSet(object.exchangeRateUsdNtd) ? String(object.exchangeRateUsdNtd) : "",
      paymentTotalUsd: isSet(object.paymentTotalUsd) ? String(object.paymentTotalUsd) : "",
    };
  },

  toJSON(message: CheckPaymentResponse): unknown {
    const obj: any = {};
    message.orderCreateTime !== undefined && (obj.orderCreateTime = message.orderCreateTime.toISOString());
    message.paymentType !== undefined && (obj.paymentType = salesOrder_PaymentTypeToJSON(message.paymentType));
    message.success !== undefined && (obj.success = message.success);
    message.paymentTotal !== undefined && (obj.paymentTotal = message.paymentTotal);
    message.recipient !== undefined &&
      (obj.recipient = message.recipient ? Recipient.toJSON(message.recipient) : undefined);
    message.paymentRemindTimeout !== undefined &&
      (obj.paymentRemindTimeout = message.paymentRemindTimeout.toISOString());
    message.receiptMethod !== undefined && (obj.receiptMethod = salesOrder_ReceiptMethodToJSON(message.receiptMethod));
    message.exchangeRateUsdNtd !== undefined && (obj.exchangeRateUsdNtd = message.exchangeRateUsdNtd);
    message.paymentTotalUsd !== undefined && (obj.paymentTotalUsd = message.paymentTotalUsd);
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckPaymentResponse>, I>>(base?: I): CheckPaymentResponse {
    return CheckPaymentResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CheckPaymentResponse>, I>>(object: I): CheckPaymentResponse {
    const message = createBaseCheckPaymentResponse();
    message.orderCreateTime = object.orderCreateTime ?? undefined;
    message.paymentType = object.paymentType ?? 0;
    message.success = object.success ?? false;
    message.paymentTotal = object.paymentTotal ?? "";
    message.recipient = (object.recipient !== undefined && object.recipient !== null)
      ? Recipient.fromPartial(object.recipient)
      : undefined;
    message.paymentRemindTimeout = object.paymentRemindTimeout ?? undefined;
    message.receiptMethod = object.receiptMethod ?? 0;
    message.exchangeRateUsdNtd = object.exchangeRateUsdNtd ?? "";
    message.paymentTotalUsd = object.paymentTotalUsd ?? "";
    return message;
  },
};

function createBaseListOrdersRequest(): ListOrdersRequest {
  return { state: 0 };
}

export const ListOrdersRequest = {
  fromJSON(object: any): ListOrdersRequest {
    return { state: isSet(object.state) ? listOrdersRequest_StateFromJSON(object.state) : 0 };
  },

  toJSON(message: ListOrdersRequest): unknown {
    const obj: any = {};
    message.state !== undefined && (obj.state = listOrdersRequest_StateToJSON(message.state));
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOrdersRequest>, I>>(base?: I): ListOrdersRequest {
    return ListOrdersRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOrdersRequest>, I>>(object: I): ListOrdersRequest {
    const message = createBaseListOrdersRequest();
    message.state = object.state ?? 0;
    return message;
  },
};

function createBaseListOrdersResponse(): ListOrdersResponse {
  return { stateOrders: {}, announcement: undefined };
}

export const ListOrdersResponse = {
  fromJSON(object: any): ListOrdersResponse {
    return {
      stateOrders: isObject(object.stateOrders)
        ? Object.entries(object.stateOrders).reduce<{ [key: number]: SalesOrders }>((acc, [key, value]) => {
          acc[Number(key)] = SalesOrders.fromJSON(value);
          return acc;
        }, {})
        : {},
      announcement: isSet(object.announcement) ? Announcement.fromJSON(object.announcement) : undefined,
    };
  },

  toJSON(message: ListOrdersResponse): unknown {
    const obj: any = {};
    obj.stateOrders = {};
    if (message.stateOrders) {
      Object.entries(message.stateOrders).forEach(([k, v]) => {
        obj.stateOrders[k] = SalesOrders.toJSON(v);
      });
    }
    message.announcement !== undefined &&
      (obj.announcement = message.announcement ? Announcement.toJSON(message.announcement) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOrdersResponse>, I>>(base?: I): ListOrdersResponse {
    return ListOrdersResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOrdersResponse>, I>>(object: I): ListOrdersResponse {
    const message = createBaseListOrdersResponse();
    message.stateOrders = Object.entries(object.stateOrders ?? {}).reduce<{ [key: number]: SalesOrders }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[Number(key)] = SalesOrders.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.announcement = (object.announcement !== undefined && object.announcement !== null)
      ? Announcement.fromPartial(object.announcement)
      : undefined;
    return message;
  },
};

function createBaseListOrdersResponse_StateOrdersEntry(): ListOrdersResponse_StateOrdersEntry {
  return { key: 0, value: undefined };
}

export const ListOrdersResponse_StateOrdersEntry = {
  fromJSON(object: any): ListOrdersResponse_StateOrdersEntry {
    return {
      key: isSet(object.key) ? Number(object.key) : 0,
      value: isSet(object.value) ? SalesOrders.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListOrdersResponse_StateOrdersEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = Math.round(message.key));
    message.value !== undefined && (obj.value = message.value ? SalesOrders.toJSON(message.value) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<ListOrdersResponse_StateOrdersEntry>, I>>(
    base?: I,
  ): ListOrdersResponse_StateOrdersEntry {
    return ListOrdersResponse_StateOrdersEntry.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ListOrdersResponse_StateOrdersEntry>, I>>(
    object: I,
  ): ListOrdersResponse_StateOrdersEntry {
    const message = createBaseListOrdersResponse_StateOrdersEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? SalesOrders.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetOrderRequest(): GetOrderRequest {
  return { id: "" };
}

export const GetOrderRequest = {
  fromJSON(object: any): GetOrderRequest {
    return { id: isSet(object.id) ? String(object.id) : "" };
  },

  toJSON(message: GetOrderRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderRequest>, I>>(base?: I): GetOrderRequest {
    return GetOrderRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderRequest>, I>>(object: I): GetOrderRequest {
    const message = createBaseGetOrderRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetOrderResponse(): GetOrderResponse {
  return { order: undefined };
}

export const GetOrderResponse = {
  fromJSON(object: any): GetOrderResponse {
    return { order: isSet(object.order) ? SalesOrder.fromJSON(object.order) : undefined };
  },

  toJSON(message: GetOrderResponse): unknown {
    const obj: any = {};
    message.order !== undefined && (obj.order = message.order ? SalesOrder.toJSON(message.order) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderResponse>, I>>(base?: I): GetOrderResponse {
    return GetOrderResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderResponse>, I>>(object: I): GetOrderResponse {
    const message = createBaseGetOrderResponse();
    message.order = (object.order !== undefined && object.order !== null)
      ? SalesOrder.fromPartial(object.order)
      : undefined;
    return message;
  },
};

function createBaseGetOrderLogisticsRequest(): GetOrderLogisticsRequest {
  return { id: "" };
}

export const GetOrderLogisticsRequest = {
  fromJSON(object: any): GetOrderLogisticsRequest {
    return { id: isSet(object.id) ? String(object.id) : "" };
  },

  toJSON(message: GetOrderLogisticsRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderLogisticsRequest>, I>>(base?: I): GetOrderLogisticsRequest {
    return GetOrderLogisticsRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderLogisticsRequest>, I>>(object: I): GetOrderLogisticsRequest {
    const message = createBaseGetOrderLogisticsRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetOrderLogisticsResponse(): GetOrderLogisticsResponse {
  return { logisticsCompanyName: "", shipmentTrackingNumber: "", routes: [] };
}

export const GetOrderLogisticsResponse = {
  fromJSON(object: any): GetOrderLogisticsResponse {
    return {
      logisticsCompanyName: isSet(object.logisticsCompanyName) ? String(object.logisticsCompanyName) : "",
      shipmentTrackingNumber: isSet(object.shipmentTrackingNumber) ? String(object.shipmentTrackingNumber) : "",
      routes: Array.isArray(object?.routes) ? object.routes.map((e: any) => SalesOrder_LogisticsRoute.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetOrderLogisticsResponse): unknown {
    const obj: any = {};
    message.logisticsCompanyName !== undefined && (obj.logisticsCompanyName = message.logisticsCompanyName);
    message.shipmentTrackingNumber !== undefined && (obj.shipmentTrackingNumber = message.shipmentTrackingNumber);
    if (message.routes) {
      obj.routes = message.routes.map((e) => e ? SalesOrder_LogisticsRoute.toJSON(e) : undefined);
    } else {
      obj.routes = [];
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderLogisticsResponse>, I>>(base?: I): GetOrderLogisticsResponse {
    return GetOrderLogisticsResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderLogisticsResponse>, I>>(object: I): GetOrderLogisticsResponse {
    const message = createBaseGetOrderLogisticsResponse();
    message.logisticsCompanyName = object.logisticsCompanyName ?? "";
    message.shipmentTrackingNumber = object.shipmentTrackingNumber ?? "";
    message.routes = object.routes?.map((e) => SalesOrder_LogisticsRoute.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateRecipientRequest(): UpdateRecipientRequest {
  return { id: "", recipient: undefined };
}

export const UpdateRecipientRequest = {
  fromJSON(object: any): UpdateRecipientRequest {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      recipient: isSet(object.recipient) ? Recipient.fromJSON(object.recipient) : undefined,
    };
  },

  toJSON(message: UpdateRecipientRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.recipient !== undefined &&
      (obj.recipient = message.recipient ? Recipient.toJSON(message.recipient) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateRecipientRequest>, I>>(base?: I): UpdateRecipientRequest {
    return UpdateRecipientRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<UpdateRecipientRequest>, I>>(object: I): UpdateRecipientRequest {
    const message = createBaseUpdateRecipientRequest();
    message.id = object.id ?? "";
    message.recipient = (object.recipient !== undefined && object.recipient !== null)
      ? Recipient.fromPartial(object.recipient)
      : undefined;
    return message;
  },
};

function createBaseCancelOrderRequest(): CancelOrderRequest {
  return { id: "" };
}

export const CancelOrderRequest = {
  fromJSON(object: any): CancelOrderRequest {
    return { id: isSet(object.id) ? String(object.id) : "" };
  },

  toJSON(message: CancelOrderRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelOrderRequest>, I>>(base?: I): CancelOrderRequest {
    return CancelOrderRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<CancelOrderRequest>, I>>(object: I): CancelOrderRequest {
    const message = createBaseCancelOrderRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDeleteOrderRequest(): DeleteOrderRequest {
  return { id: "" };
}

export const DeleteOrderRequest = {
  fromJSON(object: any): DeleteOrderRequest {
    return { id: isSet(object.id) ? String(object.id) : "" };
  },

  toJSON(message: DeleteOrderRequest): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteOrderRequest>, I>>(base?: I): DeleteOrderRequest {
    return DeleteOrderRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<DeleteOrderRequest>, I>>(object: I): DeleteOrderRequest {
    const message = createBaseDeleteOrderRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetPaymentInfoRequest(): GetPaymentInfoRequest {
  return { orderId: "", info: "" };
}

export const GetPaymentInfoRequest = {
  fromJSON(object: any): GetPaymentInfoRequest {
    return {
      orderId: isSet(object.orderId) ? String(object.orderId) : "",
      info: isSet(object.info) ? String(object.info) : "",
    };
  },

  toJSON(message: GetPaymentInfoRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.info !== undefined && (obj.info = message.info);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPaymentInfoRequest>, I>>(base?: I): GetPaymentInfoRequest {
    return GetPaymentInfoRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetPaymentInfoRequest>, I>>(object: I): GetPaymentInfoRequest {
    const message = createBaseGetPaymentInfoRequest();
    message.orderId = object.orderId ?? "";
    message.info = object.info ?? "";
    return message;
  },
};

function createBaseGetPaymentInfoResponse(): GetPaymentInfoResponse {
  return { url: "", data: "", mac: "", ksn: "" };
}

export const GetPaymentInfoResponse = {
  fromJSON(object: any): GetPaymentInfoResponse {
    return {
      url: isSet(object.url) ? String(object.url) : "",
      data: isSet(object.data) ? String(object.data) : "",
      mac: isSet(object.mac) ? String(object.mac) : "",
      ksn: isSet(object.ksn) ? String(object.ksn) : "",
    };
  },

  toJSON(message: GetPaymentInfoResponse): unknown {
    const obj: any = {};
    message.url !== undefined && (obj.url = message.url);
    message.data !== undefined && (obj.data = message.data);
    message.mac !== undefined && (obj.mac = message.mac);
    message.ksn !== undefined && (obj.ksn = message.ksn);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPaymentInfoResponse>, I>>(base?: I): GetPaymentInfoResponse {
    return GetPaymentInfoResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetPaymentInfoResponse>, I>>(object: I): GetPaymentInfoResponse {
    const message = createBaseGetPaymentInfoResponse();
    message.url = object.url ?? "";
    message.data = object.data ?? "";
    message.mac = object.mac ?? "";
    message.ksn = object.ksn ?? "";
    return message;
  },
};

function createBaseGetOrderInvoicePDFRequest(): GetOrderInvoicePDFRequest {
  return { orderId: "" };
}

export const GetOrderInvoicePDFRequest = {
  fromJSON(object: any): GetOrderInvoicePDFRequest {
    return { orderId: isSet(object.orderId) ? String(object.orderId) : "" };
  },

  toJSON(message: GetOrderInvoicePDFRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderInvoicePDFRequest>, I>>(base?: I): GetOrderInvoicePDFRequest {
    return GetOrderInvoicePDFRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderInvoicePDFRequest>, I>>(object: I): GetOrderInvoicePDFRequest {
    const message = createBaseGetOrderInvoicePDFRequest();
    message.orderId = object.orderId ?? "";
    return message;
  },
};

function createBaseGetOrderInvoicePDFResponse(): GetOrderInvoicePDFResponse {
  return { hash: "" };
}

export const GetOrderInvoicePDFResponse = {
  fromJSON(object: any): GetOrderInvoicePDFResponse {
    return { hash: isSet(object.hash) ? String(object.hash) : "" };
  },

  toJSON(message: GetOrderInvoicePDFResponse): unknown {
    const obj: any = {};
    message.hash !== undefined && (obj.hash = message.hash);
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrderInvoicePDFResponse>, I>>(base?: I): GetOrderInvoicePDFResponse {
    return GetOrderInvoicePDFResponse.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<GetOrderInvoicePDFResponse>, I>>(object: I): GetOrderInvoicePDFResponse {
    const message = createBaseGetOrderInvoicePDFResponse();
    message.hash = object.hash ?? "";
    return message;
  },
};

function createBaseValidatePaymentRequest(): ValidatePaymentRequest {
  return { orderId: "", data: "", macd: "" };
}

export const ValidatePaymentRequest = {
  fromJSON(object: any): ValidatePaymentRequest {
    return {
      orderId: isSet(object.orderId) ? String(object.orderId) : "",
      data: isSet(object.data) ? String(object.data) : "",
      macd: isSet(object.macd) ? String(object.macd) : "",
    };
  },

  toJSON(message: ValidatePaymentRequest): unknown {
    const obj: any = {};
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.data !== undefined && (obj.data = message.data);
    message.macd !== undefined && (obj.macd = message.macd);
    return obj;
  },

  create<I extends Exact<DeepPartial<ValidatePaymentRequest>, I>>(base?: I): ValidatePaymentRequest {
    return ValidatePaymentRequest.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<ValidatePaymentRequest>, I>>(object: I): ValidatePaymentRequest {
    const message = createBaseValidatePaymentRequest();
    message.orderId = object.orderId ?? "";
    message.data = object.data ?? "";
    message.macd = object.macd ?? "";
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
